/* eslint-disable react/jsx-props-no-spreading */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AccordionSection from 'yoda-core-components/lib/components/Accordion/Accordion/AccordionSection';
import YdtPlus from 'yoda-core-components/lib/assets/svg/YdtPlus.svg';
import { bool, func, number, object, objectOf, oneOfType, string } from 'prop-types';
import updateMultiSelectFacetInfo from '../../../../actions/MultiSelectFilterActions';
import FilterCategory from '../../../FilterCategory/FilterCategory';
import { updateUrl } from '../../../../utils';

/* istanbul ignore next */
class GalleryAccordionSection extends PureComponent {
    static propTypes = {
        actions: objectOf(func).isRequired,
        enableMultiSelectFilters: bool.isRequired,
        facetDetails: oneOfType([object, string]).isRequired,
        filterIndex: number.isRequired,
        multiFacetUrl: string.isRequired,
        accordionSectionClass: string,
        customClass: string,
        deviceType: objectOf(bool),
        displayCount: bool,
        isSelected: bool,
    };

    static defaultProps = {
        accordionSectionClass: '',
        customClass: '',
        deviceType: {
            isMobile: false,
            isTablet: false,
            isDesktop: true,
        },
        displayCount: true,
        isSelected: false,
    };

    filterTitleRenderer = ({ facetName, noOfSelectedFacetValues }, displayCount) => (
        <>
            <span className="capitalize font-open-sans-semibold text-medium">
                {facetName.toLowerCase()}
            </span>
            {displayCount && noOfSelectedFacetValues > 0 ? (
                <span className="font-open-sans-semibold ml-half">({noOfSelectedFacetValues})</span>
            ) : null}
        </>
    );

    accordionTitleClicked = (toOpen) => {
        const {
            deviceType: { isDesktop },
            actions,
            enableMultiSelectFilters,
            multiFacetUrl,
        } = this.props;

        if (toOpen) {
            if (enableMultiSelectFilters) {
                actions.updateMultiSelectFacetInfo({
                    enableFacetLoader: true,
                });
                multiFacetUrl && updateUrl(multiFacetUrl, null, null, null);
            }
            if (!isDesktop) {
                this.scrollPoint.nodeRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    };

    render() {
        const {
            accordionSectionClass,
            customClass,
            displayCount,
            facetDetails,
            filterIndex,
            isSelected,
        } = this.props;

        const title = this.filterTitleRenderer(facetDetails, displayCount);
        return (
            <AccordionSection
                {...this.props}
                accordionSectionClass={accordionSectionClass}
                iconComponent={<YdtPlus />}
                index={filterIndex}
                isSelected={facetDetails.activeFacet || isSelected}
                panelClick={this.accordionTitleClicked}
                ref={(input) => {
                    this.scrollPoint = input;
                }}
                renderOnExpand
                theme={`${facetDetails.facetName.replace(/ /g, '')} ${customClass}`}
                title={title}
            >
                <FilterCategory dataSource={facetDetails} />
            </AccordionSection>
        );
    }
}

const mapStateToProps = () => {
    return ({
        context: {
            deviceType: { isDesktop = true } = {},
            featureFlags: { enableMultiSelectFilters = false } = {},
        } = {},
        multiSelectFilter: { multiFacetUrl = '' } = {},
    }) => ({
        isDesktop,
        enableMultiSelectFilters,
        multiFacetUrl,
    });
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            updateMultiSelectFacetInfo,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(GalleryAccordionSection);
